// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__GIpCo","imageUploader":"EGiftCard_imageUploader__3L8DX"};